import React, { Component } from 'react'
import propTypes from 'prop-types'
import { withRouter } from 'react-router'
import { inject } from 'mobx-react'
import { Formik, Form, Field } from 'formik'
import Button from '@components/Button'
import FormError from '@components/FormError/FormError'
import pick from 'lodash/pick'
import Input from '@components/Form/Input'
import RichTextEditor from '@components/Form/RichTextEditor'
import InfoBox from '@components/InfoBox/InfoBox'
import yup from 'yup'

class EpdRejectionReasonForm extends Component {
  static propTypes = {
    epdRejectionReason: propTypes.object,
    epdRejectionReasonStore: propTypes.object,
    modalStore: propTypes.object,
    growlStore: propTypes.object
  }

  state = { error: null }

  saveEpdRejectionReason = epdRejectionReasonData => {
    const { epdRejectionReason, epdRejectionReasonStore } = this.props

    return epdRejectionReason
      ? epdRejectionReasonStore.update(
          epdRejectionReason.id,
          epdRejectionReasonData
        )
      : epdRejectionReasonStore.create(epdRejectionReasonData)
  }

  getInitialValues = () => {
    const { epdRejectionReason } = this.props

    let initialValues = {
      emailBody: '',
      emailSubject: '',
      name: ''
    }

    initialValues = epdRejectionReason
      ? pick(epdRejectionReason, Object.keys(initialValues))
      : initialValues

    return initialValues
  }

  handleSubmit = (values, actions) => {
    const { epdRejectionReasonStore, growlStore, modalStore } = this.props

    this.saveEpdRejectionReason(values)
      .then(() => {
        epdRejectionReasonStore.getEpdRejectionReasons()
        growlStore.showSuccess('EPD rejection reason saved')
        modalStore.close()
      })
      .catch(({ message }) => {
        this.setState({ error: message })
        actions.setSubmitting(false)
      })
  }

  getPlaceHolders = () => {
    return `
      The following text replacements are available:
      <ul>
        <li>
            <code>{{user.title}}</code> - Experts salutation title (e.g. Mr)
        </li>
        <li>
            <code>{{user.lastName}}</code> - Expert last name
        </li>
        <li>
            <code>{{employee.fullName}}</code> - Full name of the employee who is triggering the rejection mail
        </li>
        <li>
            <code>{{misc.text}}</code> - Misc text for ERM to fill in. Supports up to 200 characters
        </li>
      </ul>
    `
  }

  getEpdRejectionReasonValidationSchema = () => {
    return yup.object().shape({
      emailBody: yup.string().required('Email body is required'),
      emailSubject: yup.string().required('Email subject is required'),
      name: yup.string().required('Rejection reason is required')
    })
  }

  render () {
    return (
      <div className='epd-rejection-reason-form-wrapper'>
        <Formik
          initialValues={this.getInitialValues()}
          onSubmit={this.handleSubmit}
          validationSchema={this.getEpdRejectionReasonValidationSchema()}
          render={form => (
            <div className='expert-form'>
              <h1 className='expert-form__title'>
                {this.props.epdRejectionReason
                  ? 'Edit EPD rejection reason template'
                  : 'Create new EPD rejection reason template'}
              </h1>
              <FormError error={this.state.error} />
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                  <Field
                    name='name'
                    label='Rejection reason'
                    component={Input}
                  />
                  <Field
                    name='emailSubject'
                    label='Email subject'
                    component={Input}
                  />
                  <br />
                  <InfoBox className='placeholders' icon={null}>
                    <h3>Placeholders</h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.getPlaceHolders()
                      }}
                    />
                  </InfoBox>
                  <br />
                  <br />
                  <Field
                    name='emailBody'
                    label='Email body'
                    toolbarRight
                    component={RichTextEditor}
                  />
                </div>
                <div className='expert-form__section'>
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={this.props.modalStore.close}
                    disabled={form.isSubmitting}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    )
  }
}

EpdRejectionReasonForm.defaultProps = {
  hideButtons: true,
  showCloseIcon: true,
  shouldCloseOnOverlayClick: false
}

export default withRouter(
  inject('modalStore', 'growlStore')(EpdRejectionReasonForm)
)
